// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import Clipbord from 'vue-clipboard2'
import UploadProgress from './components/uploadProgress/index.js'
// import VueContextMenu from '@xunlei/vue-context-menu'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
import store from './store'
import {getRequest, postRequest, deleteRequest, putRequest, uploadFileRequest, uploadFileDo} from './utils/api.js'
import {isNotNullORBlank, setStorage, operationTips, repeatNameHandler, getStorage, hideOverflow, getUrlParamHref, getCurrentElement, getSysInfo, phoneVeri} from './utils/utils'
import './utils/filter_utils'
import ct from './utils/constant.js'
import {getFileMD5, uploadChunk, getFileSize} from './utils/upload.js'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(UploadProgress)
Vue.use(Clipbord)
// Vue.use(VueContextMenu)
Vue.prototype.getRequest = getRequest
Vue.prototype.postRequest = postRequest
Vue.prototype.deleteRequest = deleteRequest
// Vue.prototype.initMenu = initMenu
Vue.prototype.putRequest = putRequest
Vue.prototype.uploadFileRequest = uploadFileRequest
Vue.prototype.isNotNullORBlank = isNotNullORBlank
Vue.prototype.getFileMD5 = getFileMD5
Vue.prototype.uploadChunk = uploadChunk
Vue.prototype.getFileSize = getFileSize
Vue.prototype.operationTips = operationTips
Vue.prototype.repeatNameHandler = repeatNameHandler
Vue.prototype.setStorage = setStorage
Vue.prototype.getStorage = getStorage
Vue.prototype.uploadFileDo = uploadFileDo
Vue.prototype.hideOverflow = hideOverflow
Vue.prototype.getUrlParamHref = getUrlParamHref
Vue.prototype.getCurrentElement = getCurrentElement
Vue.prototype.getSysInfo = getSysInfo
Vue.prototype.phoneVeri = phoneVeri

let app = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
window.app = app

let isFromShare = parseInt(getUrlParamHref('flag')) === ct.UrlFlag.fromShare

let f = getUrlParamHref('flag')
let fn = getUrlParamHref('fn') // fileName
let g = getUrlParamHref('fileGuid')
if (f !== '' && g !== '') {
  setStorage('urlFlagParam', parseInt(f))
  setStorage('urlFGuidParam', g)
} else {
  setStorage('urlFlagParam', null)
  setStorage('urlFGuidParam', null)
}

if (fn && fn !== '') {
  setStorage('urlFileNameParam', fn)
}

router.beforeEach((to, from, next) => {
  app.$store.commit('setShowProgress', false)
  // console.log(to)
  if (to.name === ct.RouterData.login.name) {
    showOverflow()
    // next()
    // return
  } else {
    if (to.name === ct.RouterData.register.name) {
      showOverflow()
      getRequest('gcwwwifc/listEnterprise').then(res => {
        setStorage('enterpriseList', res.data.result)
      })
      // next()
    } else if (to.name === ct.RouterData.forgetPass.name) {
      showOverflow()
    } else if ((to.name === ct.RouterData.netDisk.name || to.name === ct.RouterData.allFile.name) &&
      (from.name === ct.RouterData.login.name || from.name === ct.RouterData.forgetPass.name || from.name === ct.RouterData.shared.name)) { //  || to.name === ct.RouterData.myShare.name
    // } else if (from.name === ct.RouterData.emkt.name || from.name === ct.RouterData.daiDing.name) { // todo change router name
      getHomeData()
    } else {
      hideOverflow()
      document.getElementById('app').style.minHeight = '100%'
    }
  }
  let status = app.$store.state.user.status
  if (status === '未登录') {
    // noinspection JSValidateTypes
    if (to.name === null) {
      next({path: ct.RouterData.login.path, query: {redirect: to.path}})
    } else {
      next()
    }
  } else {
    next()
  }
})

const getCusDirFile = (res) => {
  for (let i = 0; i < res.length; i++) {
    let el = res[i]
    if (el.category === ct.FileType.cus && el.fileSource === ct.UploadOrReleaseType.cus) {
      app.$store.commit('setCusDirFile', el)
      break
    }
  }
}

const showOverflow = () => {
  document.body.parentNode.style.overflow = 'auto'
}

const getHomeData = () => {
  let filesList = []
  let target = document.getElementById('app_content_file_table')
  let loading = app.$loading({text: '拼命加载中', target: target, spinner: 'el-icon-loading'})
  // getRequest('loadLoginInfo').then(res => {
  //   if (res && res.data.code === 0) {
  //     let data = res.data.result
  //     setStorage('externalNginxUrl', data.externalNginxUrl)
  //     getSysInfo(data)
  getRequest('loadHomePageData').then(res => {
    if (res && res.data.code === 0) {
      let data = res.data.result
      // app.$store.commit('setFilesList', data.files)
      filesList = data.files
      app.$store.commit('setTagsList', data.tags)
      app.$store.commit('setBanners', data.banners)
      app.$store.commit('setCustomerInfo', data.customerInfo)
      app.$store.commit('setIsCloudAdmin', data.cloudCustomer.isCloudAdmin)
      app.$store.commit('setIsCommonFileAdmin', data.cloudCustomer.isCommonFileAdmin)
      app.$store.commit('setGenechemFile', filesList.filter(r => r.fileName === '吉凯文件')[0])
      setStorage('isCloudAdmin', data.cloudCustomer.isCloudAdmin)
      setStorage('isCommonFileAdmin', data.cloudCustomer.isCommonFileAdmin)
      getCusDirFile(filesList)
      if (app.$store.state.srcPage !== null) {
        app.$store.commit('setSrcPage', 1)
      }
      getRequest('loadCloudCustomerInfo').then(res => {
        if (res && res.data.code === 0) {
          app.$store.commit('setNetDiskSpaceUsed', res.data.result)
          let flag = getStorage('urlFlagParam')
          let guid = getStorage('urlFGuidParam')
          if (flag && parseInt(flag) === ct.UrlFlag.fromEmail) { // 链接中带有flag表示来自邮件的跳转
            postRequest('loadCloudFileByGUID', guid).then(res => {
              loading.close()
              if (res) {
                app.$store.commit('setFilesList', [res.data.result])
                // app.$store.commit('setHrefFlag', flag)
                let tag = data.tags.filter(t => t.category === ct.TagCategory.all)[0]
                app.$store.commit('setCurrentTag', tag)
                // console.log('setRootFile')
                app.$store.commit('setRootFile', filesList.filter(f => !f.parentGuid)[0])
                // let href = window.location.href
                // window.location.href = href.substring(0, href.indexOf('/?')) + href.substring(href.indexOf('#/'), href.length - 1)
                // window.location.hash = ''
              }
            })
          } else {
            loading.close()
            app.$store.commit('setFilesList', filesList)
            app.$store.state.filesList.forEach(f => {
              if (!f.parentGuid) {
                app.$store.commit('setCurrentDirGuid', f.fileGuid)
                let tag = data.tags.filter(t => t.category === ct.TagCategory.all)[0]
                app.$store.commit('setCurrentTag', tag)
              }
            })
            // 链接中如果带有文件名称，调用searchFile
            if (fn && fn !== '') {
              let param = {orderColumn: 'updateDT', isDesc: true, input: fn}
              postRequest('searchFile', param).then(res => {
                if (res.data.code === 0) {
                  app.$store.commit('setFilesList', res.data.result)
                }
                loading.close()
              })
            }
          }
        } else {
          loading.close()
        }
      })
    } else {
      loading.close()
      app.$router.push(ct.RouterData.login.path)
    }
  })
  // } else {
  //   loading.close()
  //   app.$router.push(ct.RouterData.login.path)
  // }
  // })
}
// console.log('denglu')
// todo more
if (app.$store.state.user.status === '' && !isFromShare) {
  app.$router.push(ct.RouterData.netDisk.path)
}
window.getHomeData = getHomeData
// console.log('isFromShare', isFromShare)
if (!isFromShare) {
  if (f === ct.UrlFlag.fromOw) { // 'ow' ====> official website
    getRequest('loadLoginInfo').then(res => {
      // console.log('官网跳转', res.data.code)
      if (res && res.data.code === 0) {
        let data = res.data.result
        getSysInfo(data)
        if (app.$store.state.srcPage !== null) {
          app.$store.commit('setSrcPage', ct.SrcPage.all)
        }
        return true
        // app.$router.push(ct.RouterData.netDisk.path)
      } else {
        // app.$router.push(ct.RouterData.login.path)
      }
    }).then(res => {
      if (res) {
        getHomeData()
        return true
      }
    })
  } else {
    getHomeData()
  }
} else {
  app.$store.commit('setCustomerInfo', getStorage('user'))
}

// getRequest('loadLoginInfo').then(res => {
//   let app = new Vue({
//     el: '#app',
//     router,
//     store,
//     components: { App },
//     template: '<App/>'
//   })
//   window.app = app
//   let code = res.data.code
//   if (code === 1) {
//     let data = res.data.result
//     app.$store.commit('setFilesList', data.files)
//     app.$store.commit('setTagsList', data.tags)
//     setStorage('sysDictionaries', data.sysDictionaries)
//     app.$store.state.filesList.forEach(f => {
//       if (!f.parentGuid) {
//         app.$store.commit('currentDirGuid', f.fileGuid)
//       }
//     })
//   } else {
//     app.$router.push(ct.RouterData.login.path)
//   }
// }).catch(function (error) {
//   console.log('Initialization failed.')
//   console.log(error)
//   if (process.env.NODE_ENV === 'development') {
//     /* eslint-disable no-new */
//     new Vue({
//       el: '#app',
//       store,
//       router,
//       render: h => h(App)
//     })
//   } else {
//     var msg = error.message
//     if (msg) {
//       alert(error)
//     } else if (error.statusText) {
//       alert(error.statusText)
//     } else {
//       alert(error)
//     }
//   }
// })



// WEBPACK FOOTER //
// ./src/main.js